<template lang="pug">
  v-autocomplete.round-xl.icon-height(v-model="selectedCompany" :items="companies" :loading="isLoading" :disabled="disabled" item-text="name" return-object outlined dense placeholder="Select branch" :height="48" min-width="240" hide-details="auto" append-icon="$yzi-chevron-down")
    template(v-slot:no-data)
      .px-4.py-3.text-sm.neutral500--text No branch found
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: true,
    companies: [],
    selectedCompany: null,
    currentRequest: null
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      selectedCompanyFromStore: 'hq/getSelectedCompany',
      isHq: 'hq/getIsHq'
    }),
  },
  mounted() {
    // Initialize from store
    if (this.selectedCompanyFromStore) {
      this.selectedCompany = this.selectedCompanyFromStore
    } else {
      this.selectedCompany = null
    }
    this.fetchCompanies()
  },
  watch: {
    selectedCompanyFromStore: {
      handler(newValue) {
        this.selectedCompany = newValue
      },
      deep: true
    },
    selectedCompany: {
      handler() {
        // Update Vuex store when selection changes
        this.updateStore()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['showMessage']),

    fetchCompanies(stopRefetch) {
      // Cancel any existing request
      if (this.currentRequest) {
        this.currentRequest.abort()
      }

      this.isLoading = true

      // Create new AbortController for this request
      const controller = new AbortController()
      this.currentRequest = controller
      const params = {
        hq: this.company.id,
        fields: 'id,name,slug',
        page_size: -1,
        os: 'clinic'
      }
      this.$axios.get('/companies', {
        params,
        signal: controller.signal
      })
          .then(resp => {
            if (!resp.data?.results) {
              this.companies = []
              this.isLoading = false
              this.currentRequest = null
              return
            }

            this.companies = resp.data.results.map(item => {
              return {
                name: item.name,
                id: item.id,
                slug: item.slug
              }
            })

            // If no company is selected initially, don't auto-select any
            // Let user choose explicitly

            this.isLoading = false
            this.currentRequest = null
          })
          .catch(error => {
            // Don't handle aborted requests as errors
            if (error.name === 'AbortError') {
              return
            }

            if (!stopRefetch) {
              this.fetchCompanies(true)
            } else {
              this.isLoading = false
              this.currentRequest = null
            }
          })
    },
    updateStore() {
      // Store the selected company object
      this.$store.commit('hq/setSelectedCompany', this.selectedCompany)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  }
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .icon-height .v-input__control .v-input__append-inner .v-input__icon {
    height: 32px;
  }
}
</style>